// extracted by mini-css-extract-plugin
module.exports = {"dualWrapper":"DualUpload_dualWrapper__1tNdf","dualUploaderTitle":"DualUpload_dualUploaderTitle__3vkT6","dualUploadWrapper":"DualUpload_dualUploadWrapper__3eU9O"};